import { GpsType } from '../../../global/components/layout/layout-models';
import { DefaultQuickActionGroup, QuickActionGroup } from '../../../global/models/quick-actions-model';
import { BaseBlockModel, TcsmActionLink } from '../../../global/models/tcsm-block-models';

interface NewHireConfirmationModel {
	statusCode: string;
	alertType: string;
	alertDescription: string;
	title: string;
	description: string;
	nextStep: string;
	buttonText?: string;
	buttonLink?: string;
	gpsType?: GpsType;
}

export const noSelectPersonId = '-';

export interface CompensationProps {

	// individual compensation
	compensationTitle: string;
	compDescription: string;

	// current employment
	employerLabel: string;
	clientNumberLabel: string;
	employmentStatusLabel: string;
	hireDateLabel: string;
	hireDateLabelHelperText: string;
	viewEmploymentText: string;

	// current scheduled hours
	currentScheduledHoursHeader: string;
	updateScheduledHoursText: string;
	currentScheduledHoursLabel: string;
	scheduledHoursStartDateLabel: string;
	viewScheduledHoursHistoryText: string;

	// current compensation
	currentCompensationHeader: string;
	updateScheduledPaymentText: string;
	addOneTimePaymentText: string;
	scheduledPaymentsHeader: string;
	effectiveDateOfCompensationLabel: string;
	baseSalaryLabel: string;
	employerContributionLabel: string;
	cashHousingAllowanceLabel: string;
	housingHeader: string;
	providedHousingLabel: string;
	calculatedTotalsHeader: string;
	housingValueLabelDB: string;
	totalAssessableCompensationLabelDB: string;
	housingValueLabelDC: string;
	totalAssessableCompensationLabelDC: string;
	viewCompensationHistoryText: string;

	// scheduled payment
	scheduledPaymentPageTitle: string;
	scheduledPaymentDescription: string;
	compEffectiveDateLabel: string;
	annualIncomeAmountsHeader: string;
	baseSalaryScheduledTaxablePaymentsLabel: string;
	employerContributionsLabel: string;
	legalLastCashHousingAllowanceLabel: string;

	//compensation history
	amountLabel: string,
	assessableLabel: string,
	compHistoryDescription: string,
	compensationHistoryTitle: string,
	effectiveDateLabel: string,
	effectiveDateOneTimeLabel: string,
	nextButton: string,
	oneTimePaymentTitle: string,
	pageIntro: string,
	pageTitle: string,
	post2018: string,
	pre2018: string,
	prevButton: string,
	baseSalaryLabelHelperText: string,
	cashHousingAllowanceLabelHelperText: string,
	employerContributionLabelHelperText: string,
	housingValueLabelDBHelperText: string,
	housingValueLabelDCHelperText: string,
	providedHousingLabelHelperText: string,
	scheduledPaymentTitle: string,
	totalAssessableCompensationLabelDBHelperText: string,
	totalAssessableCompensationLabelDCHelperText: string,
	calculatedHousingLabel: string,
	cashHousingLabelPre2018: string,
	cashStipendLabel: string,
	churchProvidedHousingLabel: string,
	editScheduledPaymentButton: string,
	receiveMealsLabel: string,
	totalACompPre2018Label: string,
	totalRSVPPre2018Label: string,
	utilityLabel: string,
	cashHousingPre2018HelperText: string,
	cashStipendHelperText: string,
	churchProvidedHousingHelperText: string,
	receiveMealsHelperText: string,
	utilityHelperText: string,
	calculatedHousingHelperText: string,
	totalACompPre2018HelperText: string,
	totalRSVPPre2018HelperText: string,
	emptyScheduledPaymentMessage: string,
	emptyOneTimePaymentMessage: string,

	// scheduled hours
	scheduledHoursHistoryTitle: string;
	scheduledHoursHistoryDescription: string;
	scheduledHoursHeader: string;
	scheduledHoursDateLabel: string;
	scheduledHoursLabel: string;
	editScheduledHoursTitle: string;
	editScheduledHoursPageDescription: string;
	editScheduledHoursStartDateLabel: string;
	noScheduledHoursHistory: string;
	startDateAfterCurrentScheduledHoursDate: string;
	updatePositionSuggestionMessage: string;
	illnessLabel: string;
	extenuatingCircumstances: string;
	extenuatingCircumstancesDescription: string;
	terminationDateSectionTitle: string;
	terminationWarningMessage: string;
	acknowlegeIllness: string;
	acknowlegeIllnessRequiredText: string;
	below1000Message: string;
	extenuatingCircumstancesPlaceholderText: string;
	// one time payment
	oneTimePaymentPageTitle: string;
	oneTimePaymentDescription: string;
	paymentEffectiveDateLabel: string;
	paymentAmountLabel: string;

	// general messages
	noCurrentCompensationMessage: string;
	unauthorizedMessage: string;
}

export interface EmploymentProps {
	//Employment Landing
	employmentLandingTitle: string,
	employmentLandingDescription: string,
	currentEmploymentHeader: string,
	employerLabel: string,
	employmentStatusLabel: string,
	hireDateLabel: string,
	addUnpaidButtonText: string,
	stipendiaryPositionHeader: string,
	stipendiaryPositionDescription: string,
	updateStipendiaryPostionButtonText: string,
	addStipendiaryEmploymentButtonText: string,
	dateLabel: string,
	positionTitleLabel: string,
	nonStipendiaryPositionHeader: string,
	noStipendiaryPositionDescription: string,
	addNonStipendiaryButtonText: string,
	editLinkText: string,
	pageTitle: string,
	pageIntro: string,
	noStipendiaryPositionsMessage: string,
	noNonStipendiaryPositionsMessage: string,

	// positions (stip & non-stip)
	editStipPositionTitle: string,
	editStipPositionDescription: string,
	editStipPositionHeader: string,
	positionTitleLabelTooltip: string,
	publishedTitleLabel: string,
	publishedTitleLabelTooltip: string,
	positionStartDateLabel: string,
	positionEndDateLabel: string,
	stipPositionSuccessSupplement: string,
	addNonStipTitle: string,
	addNonStipPositionDescription: string,
	editNonStipTitle: string,
	editNonStipPositionDescription: string,
	addEditNonStipPositionHeader: string,
	nonStipStartDateLabel: string,

	// error messages
	positionDateOverlapErrorMessage: string,
	noEmploymentMessage: string,
	startDateBeforeHireDateError: string,

	unpaidLeaveAlerTitle: string,
	unpaidLeaveAlertMessages: string,

	termsAndConditionMessage: string,

	//Add Unpaid Leave
	addUnpaidLeaveTitle: string,
	addUnpaidLeaveDescription: string,
	beAwareMessageTitle: string,
	beAwareMessage: string,
	acknowledgeTexts: string,
	startDateLabel: string,

	//Employment and Compensation

	employmentCompensationTitle: string,
	employmentCompensationDescription: string,
	employmentSectionTitle: string,
	presentLabel: string,
	institutionLabel: string,
	scheduledHourLabel: string,
	positionLabel: string,
	dioceseLabel: string,
	addressLabel: string,
	editEmploymentLinkText: string,
	compensationSectionTitle: string,
	editCompensationLinkText: string,
	editCompensationHistoryLinkText: string,
	editCompensationNotAvailableText: string,
	editEmploymentNotAvailableText: string,
}

export interface InstitutionProps {
	clergyDbAssessmentPercentage: string;
	clergyDbEffectiveDate: string;
	dcAmendmentDate: string;
	dcBaseContribution: string;
	dcEffectiveDate: string;
	dcMatchContribution: string;
	dcMinimumSceduledHours: string;
	layDbAssessmentPercentage: string;
	layDbEffectiveDate: string;
	layDbMinimumScheduledHour: string;
	pageIntro: string;
	pageTitle: string;
	planSummaryDescription: string;
	planSummaryTitle: string;
	rsvpAmendmentDate: string;
	rsvpBaseContribution: string;
	rsvpBaseContributionType: string;
	rsvpContributionType: string;
	rsvpEffectiveDate: string;
	rsvpEligiblePopulation: string;
	rsvpMatchContribution: string;
	rsvpMatchContributionType: string;
	rsvpMinimumSceduledHours: string;
	noPlanSummaryMessage: string;
	clergyDbSectionTitle: string;
	layDcSectionTitle: string;
	layDbSectionTitle: string;
	rsvpSectionTitle: string;
	institutionDetailTitle: string;
	institutionDetailSubtitle: string;
	institutionDetailDescription: string;
	invalidWebsiteUrlMessage: string;
	//institution landing
	institutionLandingTitle: string,
	institutionLandingDescription: string,
	//institution survey
	institutionSurveyDescription: string,
	institutionSurveytitle: string,
	daySchoolQuestion: string,
	briefDescriptionLabel: string,
	cancelText: string,
	seatingCapacityLabel: string,
	specialProgramLabel: string,
	submitText: string,
	typeOfLayPensionPlanQuestion: string,
	welcomeMessageLabel: string,
	yearEstablishedLabel: string,
	houseOfServiceLabel: string,
	layPensionPlanQuestion: string,
	memberShipSizeLabel: string,
	institutionTypeLabel: string,
	seatingCapacityErrorMessage: string,
	seatingCapacityTypeErrorMessage: string,
	layPensionPlanTypeErrorMessage: string,


	// add officer
	addOfficerTitle: string;
	addOfficerDescription: string;
	officerInformationSectionTitle: string;
	officerTypeLabel: string;
	personTypeLabel: string;
	personTypeConfirmationLabel: string;
	episcopalInstitutionEmployeeOptionText: string;
	episcopalInstitutionEmployeeSupplementText: string;
	nonEpiscopalInstitutionEmployeeOptionText: string;
	nonEpiscopalInstitutionEmployeeSupplementText: string;
	personalInformationSectionTitle: string;
	addOfficerSuccessBannerMessage: string;
	addOfficerSuccessNextBestAction: string;
	officerAddSuccessMessages: string;
	officerAddSuccessNoPasswordMessages: string;
	officersLinkText: string;
	officersBusinessEmailRequiredMessage: string;
	officersBusinessEmailRequiredPrompt: string;
	withAccessLabel: string;
	mapOptionText: string;
	mapOptionHelperText: string;
	cicOptionText: string;
	cicOptionHelperText: string;
	billPayerOptionText: string;
	billPayerOptionHelperText: string;

	//compensation
	compensationPageTitle: string;
	compensationDescription: string;
	instructionLinkText: string;
	instructionLink: string;
	downloadCompensationButtonText: string;
	uploadUpdatedCompensationButtonText: string;
	compensationHelperText: string;
	compensationGpsTitle: string;
	compensationGps: Gps[];


	compensationReviewPageTitle: string;
	compensationReviewPageDescription: string;
	compensationReviewSummaryTitle: string;
	validLabel: string;
	unchangedLabel: string;
	warningLabel: string;
	errorLabel: string;
	summaryDescription: string;
	selectUpdateFileButtonText: string;
	confirmButtonText: string;
	cancelButtonText: string;
	validateErrorMessage: string;
	validateSuccessMessage: string;
	submitSuccessMessage: string;
	failedProcessingMessage: string;

	reportsInstitutionTitle: string;
	reportsInstitutionDescription: string;
	employeeListDownloadButtonText: string;
	erSummaryReportDownloadButtonText: string;
	reportNotAvailableMessage: string;
	//Diocese
	diocesanReportTitle: string;
	diocesanReportDescription: string;
	clergyReportDownloadText: string;
	layReportDownloadText: string;
	arrearsReportDownloadText: string;
	imputedIncomeReportDownloadText: string;
	institutionListDownloadText: string;
	irSummaryReportDownloadText: string;

	// Email Review.
	businessEmailReviewTitle: string;
	businessEmailReviewDescription: string;

	// Remove request
	institutionRemoveRequestTitle: string;
	institutionRemoveRequestSubtitle: string;
	institutionRemoveRequestDescription: string;
	institutionIdLabel: string;
	removalReasonLabel: string;
	circumstancesLabel: string;
	mapHomeButtonText: string;
	institutionRemoveRequestSubmittedMessage: string;
	institutionRemoveRequestSubmittedNextSteps: string;
	closingDateLabel: string;
	commentText: string;
	commentHelperText: string;
	institutionRemoveRequestSubmittedSuccessMessage: string;
	institutionRemoveRequestSubmittedPageTitle: string;
	institutionRemoveRequestSubmittedDescription: string;
	// Add request
	institutionAddRequestTitle: string;
	institutionAddRequestSubtitle: string;
	institutionAddRequestDescription: string;
	institutionAddRequestRelationshipDioceseLabel: string;
	institutionAddRequestRelationshipDioceseTooltip: string;
	institutionAddRequestContactPersonNameLabel: string;
	institutionAddRequestMailingLabel: string;
	institutionAddRequestOtherInformationLabel: string;
	institutionAddRequestSubmittedMessage: string;
	institutionAddRequestSubmittedNextSteps: string;
	institutionAddRequestSubmittedClientNumberPlaceholder: string;
	institutionAddRequestInstitutionTypeLabel: string;
	institutionAddRequestInstitutionTypeTooltip: string;
	institutionAddRequestLandingPageTitle: string;
	institutionAddRequestLandingPageWarning: string;
	institutionAddRequestStepOneTitle: string;
	institutionAddRequestStepTwoTitle: string;
	institutionAddRequestLandingPageCheckBoxMessage: string;
	redirectButtonText: string;
	dioceseLabel: string;
	yearEstablishedHelperText: string;
	yearEstablishedFormat: string;
	institutionAddRequestRelationshipStartDateLabel: string;
	relationshipStartDateHelperText: string;
	institutionTypeOtherLabel: string;
	isTecLabel: string;
	isTecHelperText: string;
	submittedSuccessMessage: string;
	submittedPageTitle: string;
	submittedDescription: string;
	//Plan Summary

	myPlansSectionTitle: string;
	currentPlansTitle: string;
	pensionPlansTitle: string;
	expandAllText: string;
	closeAllText: string;
	planHistoryLinkText: string;
	amendPlanLinkText: string;
	planNameLabel: string;
	adoptionDateLabel: string;
	billPayorLabel: string;
	billingSchdeuleLabel: string;
	planStatusLabel: string;
	lastAmendmentDateLabel: string;
	employerBaseContributionLabel: string;
	employerMatchContributionLabel: string;
	minimumScheduledHourLabel: string;
	allowMultipleContributionLabel: string;

	eligiblePopluationLabel: string;
	vestingScheduleLabel: string;
	availablePlansSectionTitle: string;
	adoptPlanButtonText: string;
	planOfferingTitle: string;
	clergyDbSectionDescription: string;
	layDbSectionDescription: string;
	layDcSectionDescription: string;
	rsvpSectionDescription: string;
	planTerminationWarningMessage: string;
	planNotActiveWarningMessage: string;

	ghlSectionTitle: string;
	medicalPlanSectionTitle: string;
	dentalPlanSectionTitle: string;
	disabilityPlanSectionTitle: string;
	stdPlanSectionTitle: string;
	ltdPlanSectionTitle: string;
	groupLifePlanSectionTitle: string;
	ueiPlanSectionTitle: string;
	planCodeLabel: string;
	billingAccountLabel: string;
	planYearLabel: string;
	planStateDateLabel: string;
	planWithYearTitle: string;
	downloadDocusignPdfLinkText: string;
	//plan history
	planHistoryTitle: string;
	terminationDateLabel: string;
	assessmentLabel: string;
	amendmentHistoryTitle: string;
	terminationHistoryTitle: string;
	dateOfChangeLabel: string;
	timeOfChangeLabel: string;
	amendmentDateLabel: string;

	//Adopt Lay DB Plan
	adoptLayDBTitle: string;
	adoptLayDBDescription: string;
	adoptLayDBDetailsTitle: string;
	adoptLayDBAdoptionInstitutionTitle: string;
	layDBEmployerAuthorizationTitle: string;
	layDBEmployerAuthorizationDescription: string;
	adoptLayDBSignLabel: string;
	adoptLayDBSignTooltip: string;
	adoptLayDBSignHelper: string;
	clientIdLabel: string;
	planAdoptionDateLabel: string;
	adoptLayDbSuccessMessage: string;
	adoptLayDbDownloadFormLinkText: string;
	layDbIndemnifyWarningTitleDc: string;
	layDbIndemnifyWarningTitleRsvp: string;
	layDbIndemnifyWarningMessage: string;
	layDbIndemnifyRsvpWarningMessage: string;
	indemnifyButtonText: string;
	indemnifyButtonHelper: string;
	layDbIndemnifySuccessMessage: string;
	layDbDocuSignSubject: string;
	layDbDocuSignTemplateId: string;
	layDbDocuSignIndemnifactionTemplateId: string;
	layDbDocuSignRejectText: string;
	layDbDocuSignFinishText: string;
	indemnifyLayDbDocuSignSubject: string;
	indemnifyLayDbDocuSignTemplateId: string;
	indemnifyLayDbDocuSignRejectText: string;
	indemnifyLayDbDocuSignFinishText: string;

	// Adopt Lay DC
	amendFormDateLabel: string;
	adoptLayDCDetailsTitle: string;
	adoptLayDCDetailsDescription: string;
	adoptLayDCadoptionInstitutionTitle: string;
	adoptLayDCEmployeeSalaryDeferText: string;
	adoptLayDCEmployerContributionText: string;
	adoptLayDCMultipleContributionDescription: string;
	adoptLayDCMultipleContributionsLabel: string;
	adoptLayDCMultipleContributionHelper: string;
	adoptLayDCMinScheduleHoursLabel: string;
	adoptLayDCMinScheduleHoursHelperText: string;
	adoptLayDCEmployerBaseContributionLabel: string;
	adoptLayDCEmployerMatchContributionLabel: string;
	adoptLayRSVPReviewTitle: string;
	adoptLayDCReviewDescription: string;
	rsvpReviewTitle: string;
	layDcReviewTitle: string;
	adoptLayDCSuccessMessage: string;
	adoptLayDCDownloadFormLinkText: string;

	amendLayDCSuccessMessage: string;
	amendLayDCDownloadFormLinkText: string;

	adoptLayDCPlanStepperLabel: string;
	amendLayDCDetailsTitle: string;
	amendLayDCDetailsDescription: string;
	amendLayDCInstitutionLabel: string;
	amendLayDCPlanStepperLabel: string;

	adoptLayDCDocuSignSubject: string;
	adoptLayDCDocuSignTemplateId: string;
	adoptIndemnifyLayDCDocuSignTemplateId: string;
	adoptLayDCDocusignFinishText: string;

	amendLayDCDocuSignSubject: string;
	amendLayDCDocuSignTemplateId: string;
	amendIndemnifyLayDCDocuSignTemplateId: string;
	amendLayDCDocusignFinishText: string;

	adoptLayDCIndemnifyDocuSignTemplateId: string;
	adoptLayDCIndemnifyDocuSignSubject: string;
	adoptLayDCIndemnifyDocuSignFinishText: string;
	adoptLayDCIndemnifyDocuSignRejectText: string;
	adoptLayDCIndemnifySignLabel: string;
	adoptLayDCIndemnifyWarningTitle: string;
	adoptLayDCIndemnifyWarningInstruction1: string;
	adoptLayDCIndemnifyWarningInstruction2: string;
	adoptLayDCIndemnifySuccessMessage: string;

	amendLayDCIndemnifyDocuSignTemplateId: string;
	amendLayDCIndemnifyDocuSignSubject: string;
	amendLayDCIndemnifyDocuSignFinishText: string;
	amendLayDCIndemnifyDocuSignRejectText: string;
	amendLayDCIndemnifySignLabel: string;
	amendLayDCIndemnifyWarningTitle: string;
	amendLayDCIndemnifyWarningInstruction1: string;
	amendLayDCIndemnifyWarningInstruction2: string;
	amendLayDCIndemnifySuccessMessage: string;

	// Generic Plan Adoption Label

	adoptionInstitutionTitle: string;
	allowMultipleContributionsCheckBoxLabel: string;
	participantNameLabel: string;
	contributionTypeLabel: string;
	contributionPercentageLabel: string;
	contributionBaseLabel: string;
	contributionMatchLabel: string;
	contributionDollarLabel: string;
	contributionOneTimeLabel: string;
	contributionPerPayrollLabel: string;
	contributionBiMonthlyLabel: string;
	contributionQuarterlyLabel: string;
	contributionTwiceYearlyLabel: string;
	contributionOtherLabel: string;
	contributionAmountLabel: string;
	contributionEditLabel: string;
	contributionRemoveLabel: string;
	contributionAddEmployeeLabel: string;
	defaultBillPayorLabel: string;
	dioceseBillPayorLabel: string;
	institutionBillPayorLabel: string;
	adoptEmployerContributionTitle: string;
	adoptMultipleContributionTitle: string;
	adoptEmployerContributionStatusTitle: string;
	percentageFormatMessage: string;
	amountFormatMessage: string;
	allowPlanSelectionPeriod: boolean;
	planSelectionPeriodMessage: string;

	employerAuthorizationTitle: string;
	employerAuthorizationDescription: string;
	indemnifyStepTitle: string;
	planDetailStepTitle: string;
	qccoStepTitle: string;
	reviewStepTitle: string;
	// QCCO Questions
	qccoLayRsvpTitle: string;
	qccoLayDCDescription: string;
	qccoRsvpDescription: string;
	qccoQuestion1Label: string;
	qccoQuestion2Label: string;
	qccoQuestion3Label: string;
	qccoQualificationStatusTitle: string;
	qccoQualificationStatusText: string;
	qccoQualificationYesStatusTitle: string;
	qccoQualificationYesStatusText: string;
	qccoQualificationNoStatusTitle: string;
	qccoQualificationNoStatusText: string;
	qccoQualificationErrorStatusTitle: string;
	qccoQualificationErrorStatusText: string;
	qccoQuestionCancelLabel: string;
	qccoQuestionSubmitLabel: string;

	// DocuSign Generic
	docuSignSignerRoleName: string;
	docuSignRejectText: string;

	// Adopt RSVP
	adoptLayRSVPDetailsTitle: string;
	adoptRSVPDetailsDescription: string;
	adoptRSVPReviewDescription: string;
	adoptRSVPEmployeeSalaryDeferText: string;
	adoptLayRSVPMemberTypeLabel: string;
	adoptLayRSVPMemberHelper: string;
	adoptLayRSVPMemberTypeClergyLabel: string;
	adoptLayRSVPMemberTypeLayLabel: string;
	adoptLayRSVPMemberTypeBothLabel: string;
	adoptRSVPEmployerContributionText: string;
	adoptRSVPMinScheduleHoursLabel: string;
	adoptRSVPMinScheduleHoursHelperText: string;
	adoptLayRSVPEmployerContributionStatus: string;
	adoptRSVPEmployerContributionScheduledLabel: string;
	adoptRSVPEmployerContributionDiscrectionLabel: string;
	adoptRSVPEmployerBaseContributionLabel: string;
	adoptRSVPEmployerMatchContributionLabel: string;
	adoptRSVPEmployerBaseContributionPercentageLabel: string;
	adoptRSVPEmployerMatchContributioDollarsLabel: string;
	adoptRSVPMultipleContributionDescription: string;
	adoptRSVPMultipleContributionHelper: string;
	adoptRSVPMultipleContributionWarningTitle: string;
	adoptRSVPMultipleContributionWarningMessage: string;
	adoptLayRSVPCancelLabel: string;
	adoptLayRSVPSubmitLabel: string;
	adoptLayRSVPReviewSubmitLabel: string;
	adoptLayRSVPReviewCancelLabel: string;

	adoptRSVPSuccessMessage: string;
	adoptRSVPDownloadFormLinkText: string;

	amendRSVPSuccessMessage: string;
	amendRSVPDownloadFormLinkText: string;

	adoptRSVPComplyEpiscopalChurchLayPensionSystemQuestion: string;

	adoptLayRSVPIndemnifyTitle: string;
	adoptLayRSVPIndemnifySubmitLabel: string;
	adoptLayRSVPIndemnifyCancelLabel: string;
	indemnifySuccessLabel: string;
	indemnifySkippedLabel: string;
	participantsMaxMessage: string;

	adoptRSVPIndemnifyDocuSignTemplateId: string;
	adoptRSVPIndemnifyDocuSignSubject: string;
	adoptRSVPIndemnifyDocuSignFinishText: string;
	adoptRSVPIndemnifyDocuSignRejectText: string;
	adoptRSVPIndemnifySignLabel: string;
	adoptRSVPIndemnifyWarningTitle: string;
	adoptRSVPIndemnifyWarningInstruction1: string;
	adoptRSVPIndemnifyWarningInstruction2: string;
	adoptRSVPIndemnifySuccessMessage: string;
	adoptRSVPIndemnifySkippedMessage: string;

	amendRSVPIndemnifyDocuSignTemplateId: string;
	amendRSVPIndemnifyDocuSignSubject: string;
	amendRSVPIndemnifyDocuSignFinishText: string;
	amendRSVPIndemnifyDocuSignRejectText: string;
	amendRSVPIndemnifySignLabel: string;
	amendRSVPIndemnifyWarningTitle: string;
	amendRSVPIndemnifyWarningInstruction1: string;
	amendRSVPIndemnifyWarningInstruction2: string;
	amendRSVPIndemnifySuccessMessage: string;
	amendRSVPIndemnifySkippedMessage: string;

	//Decline Medical dental
	declineMedicalDentalPageTitle: string;
	declineMedicalDentalSuccessMessage: string;
	declineMedicalDentalPageDescription: string;
	groupInfoSectionTitle: string;
	groupInfoHelperText: string;
	declineMedicalPlanSectionTitle: string;
	declineDentalPlanSectionTitle: string;
	availablePeriodText: string;
	declinePlanText: string;
	declinePlanHelperText: string;
	planSectionHelperText: string;
	detailLabel: string;
	ratesLabel: string;
	tier1Label: string;
	tier2Label: string;
	tier3Label: string;
	tier4Label: string;
	tier5Label: string;
	tier6Label: string;
	offerThisPlanLabel: string;
	offerPlanOptionLabel: string;
	descriptionLabel: string;
	declineMedicalDentalCancelText: string;
	declineMedicalDentalSaveText: string;
	buttonHelperText: string;
	declinedMedicalPlanSectionTitle: string;
	declinedDentalPlanSectionTitle: string;
	atLeastOnePlanRequiredMessage: string;


	amendRSVPDetailsTitle: string;
	amendRSVPDetailsDescription: string;
	amendRSVPInstitutionLabel: string;
	amendRSVPPlanStepperLabel: string;

	adoptRSVPDocuSignSubject: string;
	adoptRSVPDocuSignTemplateId: string;
	adoptIndemnifyRSVPDocuSignTemplateId: string;
	adoptRSVPDocusignFinishText: string;

	amendRSVPDocuSignSubject: string;
	amendRSVPDocuSignTemplateId: string;
	amendIndemnifyRSVPDocuSignTemplateId: string;
	amendRSVPDocusignFinishText: string;
}

export interface KeyValuePair {
	key: string,
	value: string,
}
export interface SearchProps {
	// employee search
	addressLabel: string;
	businessEmailLabel: string;
	cleryLayLabel: string;
	clientNumberLabel: string;
	dobLabel: string;
	employeeSearchPageTitle: string;
	employeeSearchPageDescription: string;
	addEmployeeLinkText: string;
	addNonStipMemberLinkText: string;
	employmentTypeLabel: string;
	filterSectionTitle: string;
	fullAddressLabel: string;
	informationLabel: string;
	nameLabel: string;
	nextButton: string;
	pageIntro: string;
	pageTitle: string;
	personalEmailLabel: string;
	previousButton: string;
	searchBarLabel: string;
	ssnLabel: string;
	statusLabel: string;
	statusTextNonStip: string;
	actionLabel: string;
	removeEmployeeButtonText: string;


	institutionSearchPageTitle: string;
	institutionNameLabel: string;
	institutionIdLabel: string;
	institutionCityLabel: string;
	institutionStatusLabel: string;
	changeInstitutionLabelText: string;
	changeDioLabelText: string;
	changeInstitutionLinkText: string;
	removalRequestPendingText: string;
	emptyListMessage: string;

	// group search
	groupSearchPageTitle: string;
	groupNameLabel: string;
	groupIDLabel: string;
	groupSearchLabel: string;
	changeGroupContextButtonText: string;
	//Billing Accounts Search
	billingAccountSearchTitle: string;
	billingAccountSearchDescription: string;
	billingAccountSearchBarLabel: string;
	billingAccountGroupIdLabel: string;
	accountNumberLabel: string;
	accountNameLabel: string;
	accountCityLabel: string;
	enrolledMembersLabel: string;
	amountDueLabel: string;
	amountDueTooltipLabel: string;
	billingHistoryLabel: string;
	billingHistoryTooltipLabel: string;
  invoicesLabel: string
	clientIdLabel: string;
	billingAccountInfoTitle: string;
	pickBillingAccounts: string;

	//participant
	participantSectionTitle: string;
	billingAccountLabel: string;
	billingAccountNumberLabel: string;
	billingAccountAddressLabel: string;
	billingAccountPhoneLabel: string;
	billingAccountAmountDueLabel: string;
	downloadEmployeeListButtonText: string;
	addParticipantButtonText: string;
	groupsWhoCanAddParticipants: string;
	billingAccountSearchBarText: string;
	participantClientNumberLabel: string;
	participantNameLabel: string;
	participantCityLabel: string;
	participantDependentLabel: string;
	annualEnrollmentStatusLabel: string;
	annualEnrollmentActionLabel: string;
	annualEnrollmentStatusFilterLabel: string;
	participantsFilterSectionTitle: string;
	annualEnrollmentStatusFilters: KeyValuePair[];
	nullEmptyAnnualEnrollmentStatusText: string;
	annualEnrollmentActionTextMapping: KeyValuePair[];
	viewAeText: string;
	enrollAeText: string;
	//Officers List
	officerListTitle: string;
	officerListDescription: string;
	addOfficerButtonText: string;
	officerUsernameLabel: string;
	officerRoleLabel: string;
	officerBusinessPhonenumber: string;
	officerEmailAddressLabel: string;
	reinviteButtonText: string;
	removeButtonText: string;
	officersRoleMapping: KeyValuePair[];
	closeModalText: string;
	removeOfficerModalTitle: string;
	removeOfficerModalDescription: string;
	removeAccessLabel: string;
	mapRoleOptionLabel: string;
	cicRoleOptionLabel: string;
	cancelText: string;
	confirmRemoveOfficerText: string;
	inviteOfficerTitle: string;
	inviteOfficerSuccessModalDescription: string;
	inviteOfficerFailModalDescription: string;
	inviteOfficerConfirmButton: string;

	//Group admin list

	groupAdminListTitle: string;
	groupAdminsListDescription: string;
	addGroupAdminsButtonText: string;
	groupAdminsUsernameLabel: string;
	groupAdminsRoleLabel: string; // Role
	groupAdminsBusinessPhonenumber: string;
	groupAdminsEmailAddressLabel: string;
	groupAdminsActionLabel: string;
	groupAdminsReinviteButtonText: string;
	groupAdminsRemoveButtonText: string;
	groupAdminRoleMapping: KeyValuePair[];
	removeAdminModalTitle: string;
	removeAdminModalDescription: string;
	confirmRemoveAdminText: string;
	inviteAdminTitle: string;
	inviteAdminSuccessModalDescription: string;
	inviteAdminFailModalDescription: string;
	inviteAdminConfirmButton: string;
	disabledAdminMessage: string;

	//diocese list
	dioceseSearchTitle: string;
	dioceseIdLabel: string;
	dioceseNameLabel: string;

	//Change Log

	employeeChangeLogTitle: string;
	employeeChangeLogDescription: string;
	employeeChangeLogFilterSectionTitle: string;
	employeeChangeLogDateTypeLabel: string;
	dateTypeSubmittedLabel: string;
	dateTypeEffectiveLabel: string;
	fromLabel: string;
	toLabel: string;
	employeeFilterLabel: string;
	employeeFilterHelperText: string;
	submittedByFilterLabel: string;
	submittedByHelperText: string;
	eventTypeFilterLabel: string;
	eventTypeFilterHelperText: string;
	applyFilterText: string;
	resetFilterText: string;
	collapseFilterText: string;
	showAllFilterText: string;
	filterOptionHelperText: string;
	submittedDateLabel: string;
	employeeLabel: string;
	eventTypeLabel: string;
	effectiveDateLabel: string;
	submittedByLabel: string;
	shortenedClientNumberLabel: string;
	downloadChangeLogText: string;
	selectedFilterLabel: string;
	clearAllText: string;
	employeeChangeLogEmptyResult: string;
	eventTypeMapping: KeyValuePair[];
	//benfit group change log

	benefitGroupChangeLogTitle: string;
	benefitGroupChangeLogDescription: string;
	submittedDateFilterTitle: string;
	dateFilterLabel: string;
	changeMadeForFilterTitle: string;
	changeMadeForHelperText: string;
	requestByFilterTitle: string;
	requestByFilterHelperText: string;
	statusFilterTitle: string;
	statusHelperText: string;
	eventTypeFilterTitle: string;
	changeTypeFilterTitle: string;
	changeTypeFilterHelperText: string;
	lastActivityDateLabel: string;
	statusRowLabel: string;
	requestByLabel: string;
	completedLabel: string;
	changeMadeForLabel: string;
	changeTypeLabel: string;
	benefitGroupChangeLogEmptyResult: string;
	benefitGroupDetailDefaultSectionTitle: string;
	benefitGroupChangeLogKeyValuePair: KeyValuePair[];
	benefitGroupChangeLogSectionMapping: KeyValuePair[];
	fieldInformationLabel: string;
	previousLabel: string;
	changedToLabel: string;
	cnLabel: string;
	eventTypeMappingBenefitsGroup: KeyValuePair[];
}

export interface PersonSearchProps {
	searchMatchesHeader: string;
	searchMatchesDescription: string;
	matchesToastAnchorText: string;
	matchesToastTitle: string;
	matchesToastMessage: string;
	matchesFoundEmbeddedTitle: string;
	matchesFoundEmbeddedMessage: string;
	clientNumberLabel: string;
	nameLabel: string;
	addressLabel: string;
	ssnLabel: string;
	actionLabel: string;
	dobLabel: string;
	genderLabel: string;
	firstNameLabel: string;
	middleNameLabel: string;
	lastNameLabel: string;
	designationLabel: string;
	businessEmailLabel: string;
	homePhoneLabel: string;
	noMatchMessage: string;
	backToTopLabel: string;
	viewFullProfileLabel: string;
	notProvidedMessage: string;
}

export interface GroupsBillingProps {
	addAdminTitle: string;
	addAdminDescription: string;
	adminInformationSectionTitle: string;
	adminTypeLabel: string;
	juniorAdminOptionText: string;
	juniorAdminSupplementText: string;
	seniorAdminOptionText: string;
	seniorAdminSupplementText: string;
	personTypeLabel: string;
	personTypeConfirmationLabel: string;
	episcopalInstitutionEmployeeOptionText: string;
	episcopalInstitutionEmployeeSupplementText: string;
	nonEpiscopalInstitutionEmployeeOptionText: string;
	nonEpiscopalInstitutionEmployeeSupplementText: string;
	personalInformationSectionTitle: string;
	groupAdminAddSuccessBannerMessage: string;
	addAdminSuccessNextBestAction: string;
	groupAdminAddSuccess: string;
	groupAdminAddNoPasswordSuccess: string;
	adminLinkText: string;
	groupAdminsBusinessEmailRequiredMessage: string;
	groupAdminsBusinessEmailRequiredPrompt: string;

	documentDownloadTitle: string;
	documentDownloadDescription: string;
	documentDownloadError: string;

	medicalDentalFormButtonText: string;
	medicalDentalFormDirectBillButtonText: string;
	groupLifeFormButtonText: string;
	dentalHealthFormButtonText: string;
	disabilityFormButtonText: string;
	businessRosterButtonText: string;
	employeeListButtonText: string;
	statementDataButtonText: string;
	ueiButtonText: string;
	glcContractTitle: string;

	reportsBenefitsGroupTitle: string;
	reportsBenefitsGroupDescription: string;
	reportsBillingAccountTitle: string;
	reportsBillingAccountDescription: string;

	reportsBenefitsGroupViewChangeTitle: string;
	reportsBenefitsGroupViewEnrollmentTitle: string;
	reportsBenefitsGroupViewAnnualEnrollmentTitle: string;
	institutionSubSelectReportTitle: string;

}


export interface AnnualEnrollmentProps {
	//Retiree Certification Step
	retireeStepBarName: string;
	retireeStepTitle: string;
	retireeDescription: string;
	retireeCancelButtonText: string;
	retireeNextButtonText: string;
	//Personal Information Step
	personalInformationStepBarName: string;
	personalInformationStepTitle: string;
	personalInformationStepDescription: string;
	personalInformationStepDescriptionMAP: string;
	personalInformationCancelButtonText: string;
	personalInformationNextButtonText: string;

	// coverage step
	singleTierLabel: string;
	familyTierLabel: string;
	empPlusOneLabel: string;
	empPlusMultiTierLabel: string;
	empPlusChildTierLabel: string;
	coverageStepBarName: string;
	childRelationshipLabel: string;
	spouseRelationshipLabel: string;
	medicalNoLongerOffered: string;
	dentalNoLongerOffered: string;
	noLongerOfferedText: string;
	coverageTitle: string;
	coverageDescription: string;
	meapCoverageDescription: string;
	currentPlanLabel: string;
	medicalPlanLabel: string;
	dentalPlanLabel: string;
	annualEnrollmentOptionsLabel: string;
	participantSelectionLabel: string;
	participantSelectionDescription: string;
	dependentAgingOutMessage: string;
	dependentCoverageBlockedMessage: string;
	dependentAdultChildWarning: string;
	selfOptionText: string;
	spouseRelationLabel: string;
	childRelationLabel: string;
	disabledChildRelationLabel: string;
	stepChildRelationLabel: string;
	domesticPartnerRelationLabel: string;
	addedText: string;
	removedText: string;
	medicalCoverageLabel: string;
	dentalCoverageLabel: string;
	unselectSelfModalMessage: string;
	unselectSelfConfirmText: string;
	unselectSelfCancelText: string;
	selectSelfModalMessage: string;
	selectSelfConfirmText: string;
	selectSelfCancelText: string;
	planSelectionLabel: string;
	planSelectionDescription: string;
	monthlyPremiumsLabel: string;
	monthlyPremiumsTooltipText: string;
	planSummaryLinkText: string;
	medicalPlansLabel: string;
	dentalPlansLabel: string;
	declineMedicalCoverageLabel: string;
	declineDentalCoverageLabel: string;
	pensionDeductionAgreementWarning: string;
	mspMessage?: string;
	mspCodes?: string;
	// Decline medical coverage no reason fields
	declineMedicalCoverageReasonGroupTitle: string;
	declineMedicalCoverageReasonSelectLabel: string;
	declineMedicalCoverageReasonSelectPlaceHolder: string;
	declineMedicalCoverageReasonSelectMessage: string;
	declineMedicalCoverageReasonOtherLabel: string;
	declineMedicalCoverageMessage: string;
	declineDentalCoverageMessage: string;
	coveragePreviousButtonText: string;
	coverageContinueButtonText: string;
	previousStepModalTitle: string;
	previousStepModalDescription: string;
	previousStepModalConfirm: string;
	previousStepModalCancel: string;
	continueHelperText: string;
	submitHelperText: string;

	coverageSummaryTitle: string;
	coverageSummaryMonthlyCostLabel: string;
	coverageSummaryMonthlyCostTooltip: string;
	coverageSummaryMonthlyCostDescription: string;
	coverageSummaryMedicalLabel: string;
	coverageSummaryDentalLabel: string;
	coverageSummaryTotalLabel: string;
	coverageDeclinedLabel: string;

	commentsHeader: string;
	myNotesLabel: string;
	specialRequestsLabel: string;
	specialRequestsDescription: string;
	planReferenceTitle: string;
	staticPlanReferenceName: string;
	staticPlanReferenceLink: string;
	pensionReductionMessage: string;

	//Relationship
	relationshipPreviousButtonText: string;
	relationshipNextButtonText: string;
	relationshipStepBarName: string;
	ineligibleDependentsWarning: string;
	dependentAgedOutWarningMessage: string;
	//Review
	reviewStepBarName: string;
	reviewHeader: string;
	reviewDescription: string;
	personalInformationHeader: string;
	editLabel: string;
	maritalStatusHeader: string;
	maritalStatusLabel: string;
	dateOfMarriageLabel: string;
	spouseInformationHeader: string;
	dependentsReviewHeader: string;
	declinedMedicalCoverageReviewText: string;
	declinedDentalCoverageReviewText: string;
	agreementLabel: string;
	pensionDeductionAgreementLabel: string;
	kaiserArbitration: string;

	//Confirmation
	confirmationPageTitle: string;
	confirmationPageDescription: string;
	confirmationPageMapDescription: string;

	adminHeldTitle: string;
	adminHeldDescription: string;
	heldTitle: string;
	heldDescription: string;
	adminConfirmationHeldTitle: string;
	adminConfirmationHeldDescription: string;
	confirmationHeldTitle: string;
	confirmationHeldDescription: string;

	planDetailSectionTitle: string;
	myCpgHomeLinkText: string;
	mapHomeLinkText: string;
	medicalPlanPdfLinkText: string;
	dentalPlanPdfLinkText: string;
	transmissionPdfLinkText: string;
	declinedMedicalCoverageText: string;
	declinedDentalCoverageText: string;
	confirmationRelationLabelText: string;
	declinedMedicalPlanText: string;
	declinedDentalPlanText: string;
	healthPlanVendorMessage: string;
	enrolledKaiserMessage: string;
	myCpgNoneActionMessage: string;
	//In Progress Section
	submittedTitle: string;
	submittedDescription: string;
	submittedBackButtonText: string;
	viewInProgressFormText: string;

	abandonFormTitle: string;
	abandonFormDescription: string;
	abandonFormButtonText: string;
	abandonFormModelDescription: string;
	abandonFormModalConfirmText: string;
	abandonFormModalCancelText: string;

	// Marital Status
	maritalDescription: string;
	maritalDescriptionMAP: string;

	//Other
	inProgressStepLabel: string;
	notStartedStepLabel: string;
	pendingSubmissionStepLabel: string;
	completedStepLabel: string;
	adminAccessMessage: string;
	characterRemainingText: string;
	maxCharacterErrorText: string;
	annualEnrollmentTitle: string;

	// Settings
	disableAnnualEnrollment: boolean;
	annualEnrollmentDeactivatedMessage: string;
	annualEnrollmentNotAvailableMessage: string;
	annualEnrollmentNotYetAvailableMemberMessage: string;
	annualEnrollmentNotYetAvailableMAPMessage: string;
	annualEnrollmentClosedMemberMessage: string;
	annualEnrollmentClosedMAPMessage: string;
	annualEnrollmentNotApplicablePlanRateMessage: string;
}

export interface PensionEnrollmentProps {
	//content
	cancelButtonText: string;
	continueToPlanDetailsButtonText: string;
	enrollButtonText: string;
	enrollmentSuccessMessageHtml: string;

	// landing page
	pensionPlansHeader: string;
	noPlansAvailableMessage: string;
	noPlansAvailableContent: string;
	noEmploymentContent: string;
	noPensionInfoContent: string;
	allPlansEnrolledContent: string;
	mapHomeButtonText: string;
	enrolledHeader: string;
	enrolledDescription: string;
	participationDateLabel: string;
	planSelectionHeader: string;
	eligiblePlansLabel: string;
	eligiblePlansDescription: string;
	notEnrolledMessages: { [key: string]: string }

	// enrollment details
	enrollmentDetailsHeader: string;
	selectedPlanHeader: string;
	selectDifferentPlanPrompt: string;
	billingOrgLabel: string;
	billingOrgLabelDescription: string;
	institutionOptionText: string;
	dioceseOptionText: string;
	participationDateLabelDescription: string;
	participationMonthLabelDescription: string;
	participationDateTooltip: string;
	monthLabel: string;
	yearLabel: string;
	pre2018EnrollmentsPrompt: string;
	pre2018EnrollmentsLinkText: string;
	pre2018EnrollmentsLink: string;
	pre2018EnrollmentsTooltip: string;
	scheduledTotalAssessableCompLabel: string;
	scheduledTotalAssessableCompTooltip: string;
	updateCompensationPrompt: string;
	compensationModalTitle: string;
	compensationModalDescription: string;
	compensationModalConfirmText: string;
	employeeContributionsHeader: string;
	employeeContributionsSubHeader: string;
	employeeContributionsDescription: string;
	employeeContributionsTooltip: string;
	byPercentageOptionText: string;
	byFixedAmountOptionText: string;
	contributionLabel: string;
	preTaxContributionLabel: string;
	employerMonthlyContributionsHeader: string;
	employerMonthlyContributionsTooltip: string;
	erBaseContributionLabel: string;
	erMatchContributionLabel: string;

	confirmLabel: string;
	confirmMessage: string;
	planHasFutureEffectiveDateWarningMessage: string;

	// marital status
	verifyMaritalStatusMessage: string;
	maritalStatusConfirmPrompt: string;
	maritalStatusLabel: string;
	maritalStatusVerifyQuestion: string;
	maritalStatusNotCorrectLinkText: string;
	singleText: string;
	maritalStatusCorrectLinkText: string;
}

export interface MidYearProps {
	coveragePageTitle: string;
	clearFormButtonText: string;
	clearFormWarningMessage: string;
	closeModalButtonText: string;
	cancelModalButtonText: string;
	confirmClearFormButtonText: string;

	childRelationLabel: string;
	spouseRelationLabel: string;
	disabledChildRelationLabel: string;
	stepChildRelationLabel: string;
	domesticPartnerRelationLabel: string;
	coverageContinueButtonText: string;
	midYearEnrollmentOptionsLabel: string;
	participantSelectionLabel: string;
	noEligibleDependentsDescription: string;
	addDependentsLinkText: string;
	participantSelectionDescription: string;
	medicalCoverageLabel: string;
	dentalCoverageLabel: string;
	planSelectionLabel: string;
	planSelectionDescription: string;
	dateOfQualifyingLabel: string;
	dateOfQualifyingTooltip: string;
	terminateCoverageHelperText: string;
	addOrEditRelationshipButtonText: string;
	billingAccountLabel: string;
	planLabel: string;
	tierLabel: string;
	rateLabel: string;
	volumeLabel: string;
	effectiveDateLabel: string;
	terminateDateLabel: string;
	effectiveDateHelperText: string;
	terminateDateHelperText: string;
	medicalPlanTitle: string;
	dentalPlanTitle: string;
	groupLifePlanTitle: string;
	supplementalLifePlanTitle: string;
	supplementalSpouseTitle: string;
	longTermTitle: string;
	shortTermTitle: string;
	unemploymentInsuranceTitle: string;
	newText: string;
	originalText: string;
	specialRequestTooltip: string;
	characterRemainingText: string;
	maxCharacterErrorText: string;
	terminationDateErrorMessage: string;
	noPlansProvidedMessage: string;
	selectBenefitsGroupMessage: string;
	selectBenefitsGroupButtonText: string;
	negativeNumberError: string;
	noPlansMessage: string;
	changeGroupLinkText: string;
	midYearFormLockedWarningMessage: string;
	midYearCafeteriaAcknowledgement: string;
	extenuatingCircumstancesLabel: string;
	extenuatingCircumstancesPlaceholder: string;
	midYearQualifyingEventWarningBannerMessage: string;
	midYearQualifyingEventInformationBannerMessage: string;

	//confirmation

	midYearConfirmationTitle: string;
	midYearConfirmationDescription: string;
	deleteFormTitle: string;
	deleteFormDescription: string;
	deleteFormButtonText: string;
	deleteFormModalDescription: string;
	deleteFormModalCancelText: string;
	deleteFormModalConfirmText: string;
	midYearConfirmationHeldTitle: string;
	midYearConfirmationHeldDescription: string;
	medicalParticipantNotEnrolledTerminatedMessage: string;
	dentalParticipantNotEnrolledTerminatedMessage: string;

	// MSP Plan
	mspPlanTitle: string;
	mspPlanLinkLabel: string;
	mspPlanLinkUrl: string;
	returnToCoverageButtonText: string;

	// Point of contact
	isContactPersonLabel: string;
	fullNameContactLabel: string;
	yourContactPhoneLabel: string;
	yourContactEmailLabel: string;
	relationshipToDeceasedLabel: string;
	contactPhoneLabel: string;
	contactEmailLabel: string;
	pointOfContactContinueButtonText: string;
	pointOfContactCancelButtonText: string;
	pointOfContactPageTitle: string;
	pointOfContactPageDescription: string;

	// Who Will Enroll
	hoursIncreaseSuccessMessage: string;
}

export interface NewHireProps {
	personalInfoStepName: string;
	personalInfoPageHeader: string;
	cancelButtonText: string;
	goBackButtonText: string;
	positionTitleLabel: string;
	positionTitleTooltip: string;
	stepNotStartedLabel: string;
	stepInProgressLabel: string;
	stepCompleteProgressLabel: string;

	// non-stip
	nonStipMemberTitle: string;
	nonStipPositionHeader: string;
	addPositionHeader: string;
	nonStipStartDateLabel: string;
	nonStipSelectedProgressLabel: string;
	nonStipTerminationDateLabel: string;
	nonStipTerminationDateTooltip: string;
	nonStipStartDateTooltip: string;
	positionStartDateLabel: string;
	positionEndDateLabel: string;
	publishedTitleLabel: string;
	publishedTitleTooltip: string;
	nonStipPositionStepName: string;
	nonStipContinueButtonText: string;
	nonStipSubmitButtonText: string;
	nonStipSubmitHelperText: string;
	nonStipEmploymentTypeStepName: string;
	nonStipEmploymentTypeTitle: string;
	nonStipEmploymentTypeLabel: string;
	layLabelText: string;
	clergyLabelText: string;
	employmentTypeBackButtonText: string;
	employmentTypeContinueButtonText: string;
	employmentTypeContinueClergyButtonText: string;
	employmentTypeButtonHelperText: string;
	employmentCompensationBackToPersonalInformationButtonText: string;
	clergyTypeTitle: string;
	clergyTypeInstructions: string;
	clergyTypeLabel: string;
	clergyTypeNonTecTitle: string;
	clergyTypeNonTecParagraph: string;
	clergyTypeNonTecWarningText: string;
	clergyTypeNonTecButtonText: string;
	clergyTypeBackButtonText: string;
	clergyTypeContinueButtonText: string;
	clergyTypeButtonHelperText: string;
	nonStipLayPositionHeader: string;
	nonStipClergyPositionHeader: string;
	// stip
	stipMemberTitle: string;
	stipImportantMessage: string;
	employmentCompensationHeader: string;
	employmentCompensationDescription: string,
	employmentHeader: string;
	employmentHireDateLabel: string;
	employmentHireDateTooltip: string;
	hoursPerYearLabel: string;
	perYearText: string;
	compEffectiveDateLabel: string;
	compensationHeader: string;
	recordTypeLabel: string;
	schedulePaymentOptionText: string;
	oneTimePaymentOptionText: string;
	oneTimePaymentHeader: string;
	oneTimePaymentTooltip: string;
	oneTimePaymentAmountLabel: string;
	scheduledPaymentHeader: string;
	scheduledPaymentTooltip: string;
	scheduledPaymentHeaderMessage: string;
	annualIncomeAmountsHeader: string;
	baseSalaryLabel: string;
	baseSalaryTooltip: string;
	employerContributionsLabel: string;
	employerContributionsTooltip: string;
	cashHousingAllowanceLabel: string;
	cashHousingAllowanceTooltip: string;
	housingHeader: string;
	employerProvidedHousingLabel: string;
	employerProvidedHousingTooltip: string;
	erPlanContributionsLabel: string;
	erPlanContributionsTooltip: string;
	employmentCompensationStepName: string;
	stipContinueButtonText: string;
	stipSubmitButtonText: string;
	stipSubmitHelperText: string;
	compensationDescription: string;
	stipEmploymentTypeStepName: string;
	stipClergyTypeStepName: string;
	stipClergyTypeStepIfApplicable: string;
	anotherDenominationLabel: string;
	dateLicensingLabel: string;
	dioceseLicensedInLabel: string;
	licensedByLabel: string;
	positionEffectiveDateLabel: string,
	scheduledHoursEffectiveDateLabel: string;
	compensationBannerMessage: string;
	baseSalaryInformationMessage: string;
	newClergyWarningTitle: string;
	newClergyWarningDescription: string;
	newClergyConfirmationTitle: string;
	newClergyConfirmationPageDescription: string;
	mapHomeButtonText: string;
	// person search
	stipInternalEmployeeMessage: string;
	nonStipInternalEmployeeMessage: string;
	stipExternalEmployeeMessage: string;
	nonStipExternalEmployeeMessage: string;
	internalEmployeeContinueButtonText: string;

	// confirmation
	stipConfirmationTitle: string;
	stipNextStepTitle: string;
	stipConfirmationDescription: string;
	stipNextStepTitleWhenUnableToProceedToEnrollment: string;
	stipConfirmationDescriptionWhenUnableToProceedToEnrollment: string;
	nonStipConfirmationTitle: string;
	nonStipNextStepTitle: string;
	nonStipConfirmationDescription: string;
	clientNumberLabel: string;
	newHireConfirmationPageSettings: NewHireConfirmationModel[];
	confirmationBackToReviewEmployeeRecordButtonText: string;
	confirmationContinueToWhoWillEnrollButtonText: string;
	confirmationMAPHomeButtonWhenUnableToProceedToEnrollment: string;
	confirmationNoteMessage: string;
	healthPlanEnrolledConfirmationMessage: string;
	layDcPlanEnrolledConfirmationMessage: string;
	layDbEnrolledConfirmationMessage: string;
	clergyDbEnrolledConfirmationMessage: string;
	rsvpEnrolledConfirmationMessage: string;
	groupLifeEnrolledConfirmationMessage: string;
	disabilityPlanEnrolledConfirmationMessage: string;
	lessThan1000HourMessage?: string;
	lessThan1000HourNoGhlMessage?: string;
	// Welcome page	
	welcomePageTitle: string;
	welcomePageDescription: string;
	welcomePageDescriptionOutsideOfEligibility: string;
	welcomePageGotoDashboardButtonText: string;
	welcomePageStartEnrollmentButtonText: string;
	benefitEnrollmentStepName: string;
	whoWillEnrollStepName: string;
	employmentRecordStepName: string;
	enrollmentTitle: string;
	memberEnrollmentTitle: string
	memberScheduledHourEnrollmentTitle: string;

	//employment comp
	continueToEmploymentCompButtonText: string;
	backToPersonalInfoButtonText: string;
	continueToWhoWillEnrollButtonText: string;
	employmentCompensationReviewPageTitle: string;
	employmentCompensationReviewPageDescription: string;
	continueToWhoWillEnrollHelperText: string;
	backToRelationshipButtonText: string;
	continueToEmployerPaidBenefitsButtonText: string;
	//Member Welcome page
	memberWelcomePageTitle: string;
	memberWelcomePageDescription: string;
	memberWelcomePageGotoDashboardButtonText: string;
	memberWelcomePageStartEnrollmentButtonText: string;

	//retirement plans
	retirementEnrollmentTitle: string;
	retirementEnrollmentDescription: string;
	retirementEnrollmentAdminDescription: string;
	eligiblePlanTitle: string;
	eligiblePlanDescription: string;
	contributionLabel: string;
	preTaxContributionLabel: string;
	employerBaseContributionLabel: string;
	employerBaseContributionHelperText: string;
	employerMatchContributionLabel: string;
	employerMatchContributionHelperText: string;
	legalNotificationTexts: string;
	retirementContinueButtonText: string;
	retirementBackButtonText: string;
	organizationNameContributionPayPeriod: string;
	effectiveDateLabel: string;
	planSelectionTitle: string;
	billingAccountLabel: string;

	employeeContributionLabel: string;
	employeeContributionLabelHelperText: string;
	employeeContributionSubLabel: string;
	continueToCoverageDescriptionText: string;
	retirementAdminContinueButtonText: string;
	retirementAdminBackButtonText: string;
	noAvailablePlanMessage: string;
	zeroContributionMessage: string;
	contributionPerPayLabel: string;
	noPlanOfferAndEnroll: string;
	noRetirementPlanEnrolledMessageForAdminReviewPage: string;
	noRetirementPlansOfferedMessage: string;
	continueButtonTextWhenNoRetirementPlansAreOffered: string;
	backToEmploymentCompButtonText: string;
	continueToCoverageButtonText: string;
	// Late Enrollment
	lateEnrollmentCoverageWarningMessage: string;
	lateEnrollmentConfirmationWarningMessage: string;

	//Retirement

	//Who will Enroll
	retirementPlanLabel: string;
	medicalPlanLabel: string;
	dentalPlanLabel: string;
	disabilityPlanLabel: string;
	stdPlanLabel: string;
	ltdPlanLabel: string;
	memberOptionText: string;
	adminOptionText: string;
	whoWillEnrollPageTitle: string;
	whoWillEnrollPageSubTitle: string;
	whoWillEnrollPageDescription: string;
	memberSelfEnrollHelperTexts: string;
	administratorOnlyLabel: string;
	administratorOnlyDescription: string;
	memberSelfEnrollAddtionalHelperTexts: string;
	continueButtonText: string;
	continueHelperText: string;
	memberSelfEnrollLabel: string;
	adminEnrollBehalfOfMemberLabel: string;
	enrollmentTypeLabel: string;
	//Benefit Enrollment
	personInfoStepName: string;
	relationshipStepName: string;
	offeredPlanStepName: string;
	offeredCoverageStepName: string;
	reviewStepName: string;

	benefitEnrollmentPersonalInfoContinueText: string;
	benefitEnrollmentPersonalInfoBackText: string;
	benefitEnrollmentRelationshipContinueText: string;
	benefitEnrollmentRelationshipBackText: string;
	//Coverage

	coverageSectionTitle: string;
	coverageDescription: string;
	coverageDiocesanAdministratorApprovalMessage: string;
	dioceseApproverCoverageSectionTitle: string;
	dioceseApproverCoverageDescription: string;
	dioceseApproverEnrollmentTitle: string;
	dioceseApproverLifeEventTitle: string;
	dioceseApproverLifeEventCoverageSectionTitle: string;
	dioceseApproverLifeEventCoverageDescription: string;
	participantSelectionDescription: string;
	taxOptionLabel: string;
	taxOptionHelperText: string;
	volumeLabel: string;
	rateLabel: string;
	rateHelper: string;
	volumeFieldLabel: string;
	singleTierLabel: string;
	familyTierLabel: string;
	empPlusOneLabel: string;
	empAndSpouseLabel: string;
	empPlusChildTierLabel: string;
	empPlusMultiTierLabel: string;
	medicalCoverageText: string;
	dentalCoverageText: string;
	medicalPlanTitle: string;
	medicalPlansLabel: string;
	declineMedicalPlanOptionText: string;
	dentalPlanTitle: string;
	dentalPlansLabel: string;
	declineDentalPlanOptionText: string;
	groupLifePlanTitle: string;
	groupLifePlansLabel: string;
	declineGroupLifePlanOptionText: string;
	longDisPlanTitle: string;
	longDisPlansLabel: string;
	declineLongDisPlanOptionText: string;
	shortDisPlanTitle: string;
	shortDisPlansLabel: string;
	declineShortDisPlanOptionText: string;
	ueiPlanTitle: string;
	ueiPlansLabel: string;
	declineUeiPlanOptionText: string;
	commentTitle: string;
	myNoteLabel: string;
	characterLimitText: string;
	specialRequestTitle: string;
	specialRequestDescription: string;
	coveragePreviousButtonText: string;
	coverageContinueButtonText: string;
	coverageContinueDescription: string;
	planSummaryLinkText: string;
	unselectSelfConfirmText: string;
	unselectSelfCancelText: string;
	selectSelfConfirmText: string;
	selectSelfCancelText: string;
	addedText: string;
	removeText: string;
	selfOptionText: string;
	selectSelfModalMessage: string;
	unselectSelfModalMessage: string;
	childRelationLabel: string;
	spouseRelationLabel: string;
	disabledChildRelationLabel: string;
	stepChildRelationLabel: string;
	domesticPartnerRelationLabel: string;
	noPlanOfferMessage: string;
	ineligibleDependentsWarning: string;

	declineCoverageReasonSelectMessage: string;
	declineCoverageReasonOtherLabel: string;
	declineCoverageReasonGroupTitle: string;
	declineCoverageReasonSelectLabel: string;
	declineCoverageReasonSelectPlaceHolder: string;
	groupLifeVolumeMaxDigitsValidationLabel: string;
	groupLifeVolumeMaxDecimalDigitsValidationLabel: string;
	medicalPlanToMemberReviewMessage: string;
	medicalPlanToMemberDeclinedReviewMessage: string;
	dentalPlanToMemberReviewMessage: string;
	dentalPlanToMemberDeclinedReviewMessage: string;
	stdPlanToMemberReviewMessage: string;
	stdPlanToMemberDeclinedReviewMessage: string;
	ltdPlanToMemberReviewMessage: string;
	ltdPlanToMemberDeclinedReviewMessage: string;
	ueiPlanToMemberReviewMessage: string;
	ueiPlanToMemberDeclinedReviewMessage: string;
	memberCoverageContinueDescription: string;
	volumeNotSetMessage: string;
	volumeFieldWarningMessage: string;
	dioceseApproverVolumeFieldWarningMessage: string;
	premiumFieldWarningMessage: string;
	dioceseApproverPremiumFieldWarningMessage: string;
	groupRateSummaryInstitutionAdminSectionLabel: string;
	dioceseApproverHeaderWarningMessage: string;
	dioceseApproverHeaderWarningTitle: string;
	dioceseApproverHeaderWarningUrlText: string;
	dioceseApproverLifeEventBannerMessage: string;
	unExpectedApiErorrMessage: string;
	//review
	reviewTitle: string;
	reviewDescription: string;
	dioceseApproverReviewTitle: string;
	dioceseApproverReviewDescription: string;
	personalInfoReviewSectionTitle: string;
	maritalStatusReviewSectionTitle: string;
	spouseInfoSectionTitle: string;
	dependentSectionTitle: string;
	employmentCompSectionTitle: string;
	presentLabel: string;
	employmentTitle: string;
	institutionLabel: string;
	positionLabel: string;
	dioLabel: string;
	addressLabel: string;
	compensationTitle: string;
	dbHousingValueLabel: string;
	dbHousingValueHelper: string;
	dcHousingValueLabel: string;
	dcHousingValueHelper: string;
	dbCompTotalLabel: string;
	dbCompTotalHelper: string;
	dcCompTotalLabel: string;
	dcCompTotalHelper: string;
	reviewPensionSectionTitle: string;
	memberContributionAmountLabel: string;
	memberContributionPercentLabel: string;
	participantReviewSectionTitle: string;
	healthPlanReviewSectionTitle: string;
	summarySectionTitle: string;
	monthlyCostLabel: string;
	monthlyCostHelper: string;
	monthlyCostHealthLabel: string;
	monthlyCostHealthHelper: string;
	healthSubTotalLabel: string;
	groupCostLabel: string;
	groupCostHelper: string;
	groupCostSubTotalLabel: string;
	disabilityCostLabel: string;
	disabilityCostHelper: string;
	disabilitySubTotalLabel: string;
	ueiCostLabel: string;
	ueiCostHelper: string;
	ueiSubTotalLabel: string;
	totalCostLabel: string;
	totalCostDescription: string;
	coverageReviewCheckBoxText: string;
	participantCoverageReviewCheckBoxText: string;
	adminCafeteriaAcknowledgement: string;
	coverageReviewSubmitText: string;
	coverageReviewBackText: string;
	coverageReviewSubmitHelperText: string;
	dioceseApproverCoverageReviewSubmitText: string;
	dioceseApproverCoverageReviewBackText: string;
	dioceseApproverReviewSubmitHelperText: string;
	dioceseApproverLifeEventReviewSubmitHelperText
	declineMedicalCoverageMessage: string;
	declineDentalCoverageMessage: string;
	declineGroupCoverageMessage: string;
	declineLtdCoverageMessage: string;
	declineStdCoverageMessage: string;
	declineUeiCoverageMessage: string;
	groupLifeRateValueNotAvailable: string;
	adminAccessMessage: string;
	memberCafeteriaAcknowledgement: string;
	pendingMemberReviewMessage: string;
	institutionAdminPlanSelectionWarningMessage: string;
	submittedByLabel: string;
	submitterContactInfoLabel: string;
	submitterBusinessEmailLabel: string;
	submitterBusinessPhoneLabel: string;
	pendingMemberForMedicalMemberChangesMessage: string;
	pendingMemberForDentalMemberChangesMessage: string;
	dioceseApproverLifeEventReviewSectionTitle: string;
	dioceseApproverLifeEventReviewDescription: string;
	dioceseApproverLifeEventCoverageReviewBackText: string;
	dioceseApproverLifeEventCoverageReviewSubmitText: string;
	invalidValueHasBeenSetMessage: string;

	//Scheduled Hour Increase
	scheduledHourEnrollmentTitle: string;
	scheduledHourWhoWillEnrollDescription: string;
}

export interface TerminationProps {
	generalErrorMessage: string;
	employmentTerminationHeader: string;
	employmentTerminationDescription: string;
	terminationInfoHeader: string;
	employeeLabel: string;
	clientNumberLabel: string;
	employerLabel: string;
	employmentTypeLabel: string;
	stipendiaryText: string;
	nonStipendiaryText: string;
	hireDateLabel: string;
	terminationTypeLabel: string;
	employmentOptionLabel: string;
	employmentTypePrompt: string;
	lastDayWorkedLabel: string;
	dontKnowDateText: string;
	dontKnowTerminationDateTooltip: string;
	employmentTerminationMessage: string;
	deathOptionLabel: string;
	dateOfDeathLabel: string;
	dontKnowDeathDateTooltip: string;
	neverWorkedHereOptionLabel: string;
	effectiveDateLabel: string;
	leaveOfAbsenceAcknowledge: string;
	leaveOfAbsenceWarningTitle: string;
	leaveOfAbsenceAcknowledgeRequiredMessage: string;
	loaWarningMessage: string;
	leaveOfAbsencePageTitle: string;
	leaveOfAbsencePageDescription: string;
	loaTerminateBenefitTitle: string;
	loaDropdownLabel: string;
	cancelButtonText: string;
	submitButtonText: string;
	confirmTerminationModalDescription: string;
	modalConfirmButtonText: string;
	modalCancelButtonText: string;
	terminationSuccessBannerMessage: string;
	isRetiringLabel: string;
	extenuatingLabel: string;
	extenuatingDescription: string;
	benefitTitle: string;
	planTypeLabel: string;
	terminateDateLabel: string;
	extenuatingTooltip: string;
	sameDayWarning: string;
	nonExtenuatingWarning: string;
	nintyPlusWarning: string;
	benefitTerminatedHeader: string;

	// stip confirmation
	stipConfirmationTitle: string;
	stipTerminatedEmployeeHeader: string;
	stipTerminatedEmployeeDescription: string;
	stipTerminatedEmployeeDateUnderReviewDescription: string;
	stipTerminatedEmployeeCircumstancesUnderReviewDescription: string;
	stipNextStepsHeader: string;
	stipGroupHealthLifeMessage: string;
	stipTerminateBenefitsLinkText: string;
	stipNonGroupAdminNextStepsMessage: string;

	// non-stip confirmation
	nonStipConfirmationTitle: string;
	nonStipTerminatedEmployeeHeader: string;
	nonStipTerminatedEmployeeDescription: string;
	nonStipTerminatedEmployeeDateUnderReviewDescription: string;
	nonStipTerminatedEmployeeCircumstancesUnderReviewDescription: string;
	nonStipNextStepsHeader: string;
	nonStipGroupHealthLifeMessage: string;
	nonStipTerminateBenefitsLinkText: string;
	nonStipNonGroupAdminNextStepsMessage: string;

	// stip & non-stip confirmation
	stipNonStipConfirmationTitle: string;
	stipNonStipTerminatedEmployeeHeader: string;
	stipNonStipTerminatedEmployeeDescription: string;
	stipNonStipTerminatedEmployeeDateUnderReviewDescription: string;
	stipNonStipTerminatedEmployeeCircumstancesUnderReviewDescription: string;
	stipNonStipNextStepsHeader: string;
	stipNonStipGroupHealthLifeMessage: string;
	stipNonStipTerminateBenefitsLinkText: string;
	stipNonStipNonGroupAdminNextStepsMessage: string;
	employmentBenefitTerminationMessage: string;
	retroExtenBenefitTerminationMessage: string;

	// death confirmation
	deathConfirmationTitle: string;
	deathTerminatedEmployeeHeader: string;
	deathTerminatedEmployeeDescription: string;
	deathBottomMessage: string;

	// person never worked here confirmation
	neverWorkedHereConfirmationTitle: string;
	neverWorkedHereTerminatedEmployeeHeader: string;
	neverWorkedHereEffectiveDescription: string;

	//Unpaid Leave
	loaConfirmationTitle: string;
	loaTerminatedEmployeeHeader: string;
	loaTerminatedEmployeeDescription: string;
	loaNextStepsHeader: string;
	loaGroupHealthLifeMessage: string;
	loaTerminateBenefitsLinkText: string;
	loaGroupAdminNextStepsMessage: string;
	loaSubmitSuccessMessage: string;
	loaBenefitTerminatedDescription: string;
	loaEffectiveDescription: string;
	loaNotAvailableMessage: string;
	unpaidLeaveEffectiveDateLabel: string;
}


export interface GpsItem {
	linkText: string,
	modalTitle: string,
	modalDescription: string,
	downloadText: string,
	downloadLink: string,
	externalDownloadLink: string,
	externalUrl: any,
}

export interface Gps {
	title: string,
	gpsItems: GpsItem[],
}

export interface GuidedProcessSupportProps {
	guidedSupportSectionTitle: string,
	demographicSectionArea: Gps[],

	guidedSupportMaritalStatusTitle: string,
	maritalStatusSectionArea: Gps[],
	addDependentSectionTitle: string,
	addDependentSectionArea: Gps[],
	editDependentSectionTitle: string,
	editDependentSectionArea: Gps[],
	scheduledHourSectionTitle: string,
	scheduledHourSectionArea: Gps[],
	scheduledHourHistorySectionTitle: string,
	scheduledHourHistorySectionArea: Gps[],
	updateScheduledPaymentSectionTitle: string,
	updateScheduledPaymentSectionArea: Gps[],
	oneTimePaymentSectionTitle: string,
	oneTimePaymentSectionArea: Gps[],
	compensationHistorySectionTitle: string,
	compensationHistorySectionArea: Gps[],
	updateStipePositionSectionTitle: string,
	updateStipeSectionArea: Gps[],
	nonStipeSectionTitle: string,
	nonStipeSectionArea: Gps[],
	editStipeSectionTitle: string,
	editStipeSectionArea: Gps[],
	addNonStipeSectionTitle: string,
	addNonStipeSectionArea: Gps[],
	employeeListSectionTitle: string,
	employeeListSectionArea: Gps[],
	relationshipSectionTitle: string,
	relationshipSectionArea: Gps[],
	compensationSectionTitle: string,
	compensationSectionArea: Gps[],
	employmentSectionTitle: string,
	employmentSectionArea: Gps[],
	mapDocumentUploadSectionTitle: string,
	mapDocumentUploadSectionArea: Gps[],
	benefitsSurveyGpsTitle: string;
	benefitsSurveyGps: Gps[];
	//mycpg
	myCpgDemographicTitle: string,
	myCpgDemographicSectionArea: Gps[],
	myCpgRelationshipSectionTitle: string,
	myCpgRelationshipSectionArea: Gps[],
	myCpgGuidedSupportMaritalStatusTitle: string,
	myCpgMaritalStatusSectionArea: Gps[],
	myCpgAddDependentSectionTitle: string,
	myCpgAddDependentSectionArea: Gps[],
	myCpgEditDependentSectionTitle: string,
	myCpgEditDependentSectionArea: Gps[],
	myCpgDocumentUploadSectionTitle: string,
	myCpgDocumentUploadSectionArea: Gps[],
	myCpgDomesticPartnerSectionTitle: string,
	myCpgDomesticPartnerSectionArea: Gps[],
	mycpgBillingTitle: string,
	mycpgBillingSectionArea: Gps[],

	//map institution
	institutionListTitle: string,
	institutionListSectionArea: Gps[],
	institutionDetailSectionTitle: string,
	institutionDetailSectionArea: Gps[],
	institutionDemoSectionTitle: string,
	institutionDemoSectionArea: Gps[],
	planSummarySectionTitle: string,
	planSummarySectionArea: Gps[],
	addOfficerSectionTitle: string,
	addOfficerSectionArea: Gps[],
	addOfficerConfrimationSectionTitle: string,
	addOfficerConfrimationSectionArea: Gps[],
	addOfficerReviewSectionTitle: string,
	addOfficerReviewSectionArea: Gps[],
	institutionReportsGpsTitle: string,
	institutionReportsGps: Gps[],
	diocesanReportsGpsTitle: string,
	diocesanReportsGps: Gps[],
	institutionAddRequestTitle: string,
	institutionAddRequestSectionArea: Gps[],
	institutionAddRequestSubmittedTitle: string,
	institutionAddRequestSubmittedSectionArea: Gps[],
	institutionRemoveRequestTitle: string,
	institutionRemoveRequestSectionArea: Gps[],
	institutionRemoveRequestSubmittedTitle: string,
	institutionRemoveRequestSubmittedSectionArea: Gps[],

	adoptLayDbGpsTitle: string,
	adoptLayDbGps: Gps[],
	declineMedicalDentalTitle: string,
	declineMedicalDentalSectionArea: Gps[],

	//lay dc
	layDcAdoptionDetailTitle: string,
	layDcAdoptionDetailSectionArea: Gps[],
	layDcAdoptionQuestionsTitle: string,
	layDcAdoptionQuestionsSectionArea: Gps[],
	layDcAdoptionReviewTitle: string,
	layDcAdoptionReviewSectionArea: Gps[],
	layDcAdoptionIndemnifyTitle: string,
	layDcAdoptionIndemnifySectionArea: Gps[],

	//lay dc amend
	layDcAmendPlanDetailTitle: string,
	layDcAmendPlanDetailSectionArea: Gps[],
	layDcAmendQuestionsTitle: string,
	layDcAmendQuestionsSectionArea: Gps[],
	layDcAmendReviewTitle: string,
	layDcAmendReviewSectionArea: Gps[],
	layDcAmendIndemnifyTitle: string,
	layDcAmendIndemnifySectionArea: Gps[],

	//rsvp
	rsvpAdoptionDetailTitle: string,
	rsvpAdoptionDetailSectionArea: Gps[],
	rsvpAdoptionQuestionsTitle: string,
	rsvpAdoptionQuestionsSectionArea: Gps[],
	rsvpAdoptionReviewTitle: string,
	rsvpAdoptionReviewSectionArea: Gps[],
	rsvpAdoptionIndemnifyTitle: string,
	rsvpAdoptionIndemnifySectionArea: Gps[],

	//rsvp amend
	rsvpAmendDetailTitle: string,
	rsvpAmendDetailSectionArea: Gps[],
	rsvpAmendQuestionsTitle: string,
	rsvpAmendQuestionsSectionArea: Gps[],
	rsvpAmendReviewTitle: string,
	rsvpAmendReviewSectionArea: Gps[],
	rsvpAmendIndemnifyTitle: string,
	rsvpAmendIndemnifySectionArea: Gps[],

	//map group
	groupListSectionTitle: string,
	groupListSectionArea: Gps[],
	billingAccountsSectionTitle: string,
	billingAccountsSectionArea: Gps[],
	participantListSectionTitle: string,
	participantListSectionArea: Gps[],
	groupAdminSectionTitle: string,
	groupAdminSectionArea: Gps[],
	addAdminSectionTitle: string,
	addAdminSectionArea: Gps[],
	addAdminConfrimationSectionTitle: string,
	addAdminConfrimationSectionArea: Gps[],
	addAdminReviewSectionTitle: string,
	addAdminReviewSectionArea: Gps[],
	downloadSectionTitle: string,
	downloadSectionArea: Gps[],
	groupSearchGpsTitle: string;
	groupSearchGps: Gps[];
	billingAccountReportsGpsTitle: string;
	billingAccountReportsGps: Gps[];
	benefitsGroupReportsGpsTitle: string;
	benefitsGroupReportsGps: Gps[];

	//AE
	aeMyCpgDemographicTitle: string,
	aeMyCpgDemographicSectionArea: Gps[],
	aeMyCpgRelationshipSectionTitle: string,
	aeMyCpgRelationshipSectionArea: Gps[],
	aeMyCpgGuidedSupportMaritalStatusTitle: string,
	aeMyCpgMaritalStatusSectionArea: Gps[],
	aeMyCpgDependentSectionTitle: string,
	aeMyCpgDependentSectionArea: Gps[],
	aeMyCpgCoverageSectionTitle: string,
	aeMyCpgCoverageSectionArea: Gps[],
	aeMyCpgReviewSectionTitle: string,
	aeMyCpgReviewSectionArea: Gps[],
	aeMyCpgConfirmationSectionTitle: string,
	aeMyCpgConfirmationSectionArea: Gps[],
	aeMapDemographicTitle: string,
	aeMapDemographicSectionArea: Gps[],
	aeMapRelationshipSectionTitle: string,
	aeMapRelationshipSectionArea: Gps[],
	aeMapGuidedSupportMaritalStatusTitle: string,
	aeMapMaritalStatusSectionArea: Gps[],
	aeMapDependentSectionTitle: string,
	aeMapDependentSectionArea: Gps[],
	aeMapCoverageSectionTitle: string,
	aeMapCoverageSectionArea: Gps[],
	aeMapReviewSectionTitle: string,
	aeMapReviewSectionArea: Gps[],
	aeMapConfirmationSectionTitle: string,
	aeMapConfirmationSectionArea: Gps[],
	aeMapInterruptSectionTitle: string,
	aeMapInterruptSectionArea: Gps[],
	aeMapSubmittedSectionTitle: string,
	aeMapSubmittedSectionArea: Gps[],
	aeHeldSectionTitle: string,
	aeHeldSectionArea: Gps[],
	aeMapHeldSectionTitle: string,
	aeMapHeldSectionArea: Gps[],
	//mid year
	midYearCoverageSectionTitle: string,
	midYearCoverageSectionArea: Gps[],
	midYearInHeldSectionTitle: string,
	midYearInHeldSectionArea: Gps[],
	midYearInProgressSectionTitle: string,
	midYearInProgressSectionArea: Gps[],
	myCpgMidYearWelcomePageSectionTitle: string,
	myCpgMidYearWelcomePageGuidedProcessSupport: Gps[],
	myCpgMidYearDioApproverCoverageGPSTitle: string,
	myCpgMidYearDioApproverCoverageGPSSectionArea: Gps[],
	myCpgMidYearDioApproverReviewGPSTitle: string,
	myCpgMidYearDioApproverReviewGPSSectionArea: Gps[],

	//alert
	alertAndNotificationSectionTitle: string,
	alertAndNotificationSectionArea: Gps[],

	//new hire

	newHireDemoSectionTitle: string,
	newHireDemoSectionArea: Gps[],
	newHireStipendiarySectionTitle: string,
	newHireStipendiarySectionArea: Gps[],
	newHireNonStipSectionTitle: string,
	newHireNonStipSectionArea: Gps[],
	newHireStipConfirmationSectionTitle: string,
	newHireStipConfirmationSectionArea: Gps[],
	newHireNonStipConfirmationSectionTitle: string,
	newHireNonStipConfirmationSectionArea: Gps[],
	newHireSearchOutsideSectionTitle: string,
	newHireSearchOutSideSectionArea: Gps[],
	newHireSearchInsideSectionTitle: string,
	newHireSearchInsideSectionArea: Gps[],
	newHireEnrollmentLandingSectionTitle: string,
	newHireEnrollmentLandingSectionArea: Gps[],
	newHireEnrollmentLandingNotEligibleSectionTitle: string,
	newHireEnrollmentLandingNotEligibleSectionArea: Gps[],

	newHireSearchNonStipeEmploymentTypeTitle: string,
	newHireSearchNonStipeEmploymentTypeSectionArea: Gps[],
	newHireRetirementTitle: string,
	newHireRetirementSectionArea: Gps[],
	newHireClergyTypeTitle: string,
	newHireClergyTypeSectionArea: Gps[],
	newHireRetirementAdminTitle: string,
	newHireRetirementAdminGps: Gps[],
	newHireWhoWillEnrollTitle: string,
	newHireWhoWillEnrollGps: Gps[],
	newHirePersonInfoTitle: string,
	newHirePersonInfoGps: Gps[],
	newHireRelationshipTitle: string,
	newHireRelationshipGps: Gps[],
	newHireMaritalStatusTitle: string,
	newHireMaritalStatusGps: Gps[],
	newHireDependentTitle: string,
	newHireDependentGps: Gps[],
	newHireCoverageAdminTitle: string,
	newHireCoverageAdminGps: Gps[],
	newHireReviewAdminTitle: string,
	newHireReviewAdminGps: Gps[],
	dioceseApproverCoveragePageGuidedProcessSupportTitle: string,
	dioceseApproverCoveragePageGuidedProcessSupport: Gps[],
	dioceseApproverCoverageReviewPageGuidedProcessSupportTitle: string,
	dioceseApproverCoverageReviewPageGuidedProcessSupport: Gps[],
	dioceseApproverConfirmationRejectPageGuidedProcessSupportTitle: string,
	dioceseApproverConfirmationRejectPageGuidedProcessSupport: Gps[],
	dioceseApproverConfirmationApprovePageGuidedProcessSupportTitle: string,
	dioceseApproverConfirmationApprovePageGuidedProcessSupport: Gps[],
	institutionAdminPendingApprovalGpsTitle: string,
	institutionAdminPendingApprovalGps: Gps[],
	newHireClergyTypeGpsTitle: string,
	newHireClergyTypeGps: Gps[],

	//new hire member
	memberNewHireEnrollmentLandingSectionTitle: string,
	memberNewHireEnrollmentLandingSectionArea: Gps[],
	memberNewHirePersonInfoTitle: string,
	memberNewHirePersonInfoGps: Gps[],
	memberNewHireRelationshipTitle: string,
	memberNewHireRelationshipGps: Gps[],
	memberNewHireMaritalStatusTitle: string,
	memberNewHireMaritalStatusGps: Gps[],
	memberNewHireEmploymentTitle: string,
	memberNewHireEmploymentGps: Gps[],
	memberNewHireRetirementTitle: string,
	memberNewHireRetirementGps: Gps[],
	memberNewHireCoverageTitle: string,
	memberNewHireCoverageGps: Gps[],

	memberNewHireDependentTitle: string,
	memberNewHireDependentGps: Gps[],
	memberNewHireReviewTitle: string,
	memberNewHireReviewGps: Gps[],
	newHireByDioConfirmationTitle: string,
	newHireByDioConfirmationGps: Gps[],
	newHireByMemberConfirmationTitle: string,
	newHireByMemberConfirmationGps: Gps[],
	// pension enrollment
	pensionEnrollmentSectionTitle: string,
	pensionEnrollmentSectionArea: string,

	// termination
	terminationFormSectionTitle: string,
	terminationFormSectionArea: Gps[],

	stipNonStipTerminationConfirmationSectionTitle: string,
	stipNonStipTerminationConfirmationSectionArea: Gps[],
	stipTerminationConfirmationSectionTitle: string,
	stipTerminationConfirmationSectionArea: Gps[],
	nonStipTerminationConfirmationSectionTitle: string,
	nonStipTerminationConfirmationSectionArea: Gps[],
	deathTerminationConfirmationSectionTitle: string,
	deathTerminationConfirmationSectionArea: Gps[],
	neverWorkedHereTerminationConfirmationSectionTitle: string,
	neverWorkedHereTerminationConfirmationSectionArea: Gps[],
	employmentCompensationTitle: string,
	employmentCompensationGps: Gps[],
	employmentHistoryTitle: string,
	employmentHistoryGps: Gps[],
	//diocese search
	dioceseSearchGpsTitle: string,
	dioceseSearchGps: Gps[],
	loaGpsTitle: string,
	loaGps: Gps[],

	// My Documents
	myDocumentsGpsTitle: string,
	myDocumentsGps: Gps[],
	compensationGpsTitle: string,
	compensationGps: Gps[],
	pensionGpsTitle: string,
	pensionGps: Gps[],
	dcGpsTitle: string,
	dcGps: Gps[],
	healthGpsTitle: string,
	healthGps: Gps[],
	annuityGpsTitle: string,
	annuityGps: Gps[],
	rsvpGpsTitle: string,
	rsvpGps: Gps[],
	disabilityGpsTitle: string,
	disabilityGps: Gps[],
	lifeGpsTitle: string,
	lifeGps: Gps[],


	//Participant Enrollment
	participantWhoWillEnrollTitle: string,
	participantWhoWillEnrollGps: Gps[],
	participantPersonalInfoTitle: string,
	participantPersonalInfoGps: Gps[],
	participantRelationshipTitle: string,
	participantRelationshipGps: Gps[],
	participantCoverageTitle: string,
	participantCoverageGps: Gps[],
	participantRetirementTitle: string,
	participantRetirementGps: Gps[],
	createNewParticipantTitle: string,
	createNewParticipantGps: Gps[],
	participantCoverageReviewTitle: string,
	participantCoverageReviewGps: Gps[],
	participantConfirmationTitle: string,
	participantConfirmationGps: Gps[],
	//Beneficiary
	beneficiaryLandingTitle: string,
	beneficiaryLandingGps: Gps[],
	beneficiaryUpdateTitle: string,
	beneficiaryUpdateGps: Gps[],
	beneficiaryCreateTitle: string,
	beneficiaryCreateGps: Gps[],

	//MyCpg Mid Year
	myCpgMidYearPersonalInfoSectionTitle: string,
	myCpgMidYearPersonalInfoSectionArea: Gps[],
	myCpgMidYearRelationshipSectionTitle: string,
	myCpgMidYearRelationshipSectionArea: Gps[],
	myCpgMidYearMaritalStatusSectionTitle: string,
	myCpgMidYearMaritalStatusSectionArea: Gps[],
	myCpgMidYearDependentSectionTitle: string,
	myCpgMidYearDependentSectionArea: Gps[],
	myCpgMidYearCoverageSectionTitle: string,
	myCpgMidYearCoverageSectionArea: Gps[],
	myCpgMidYearReviewSectionTitle: string,
	myCpgMidYearReviewSectionArea: Gps[],
	myCpgDependentGainingHealthBenefitsSectionTitle: string,
	myCpgDependentGainingHealthBenefitsSectionArea: Gps[],
	myCpgMidYearChangeInSpouseOrDomesticPartnerSectionTitle: string,
	myCpgChangeInSpouseOrDomesticPartnerSectionArea: Gps[],
	myCpgLossOfCoverageSectionTitle: string,
	myCpgLossOfCoverageSectionArea: Gps[],
	myCpgSignificantChangeInMedicalSectionTitle: string,
	myCpgSignificantChangeInMedicalSectionArea: Gps[],
	myCpgEnrollmentQualifiedHealthPlanSectionTitle: string,
	myCpgEnrollmentQualifiedHealthPlanSectionArea: Gps[],


	myCpgMidYearConfirmationMarriageGPSTitle: string,
	myCpgMidYearConfirmationMarriageGPSSectionArea: Gps[],


	myCpgMidYearConfirmationLegalSeparationGPSTitle: string,
	myCpgMidYearConfirmationLegalSeparationGPSSectionArea: Gps[],


	myCpgMidYearConfirmationDomesticPartnershipGPSTitle: string,
	myCpgMidYearConfirmationDomesticPartnershipGPSSectionArea: Gps[],

	myCpgMidYearConfirmationDissolutionDomesticPartnershipGPSTitle: string,
	myCpgMidYearConfirmationDissolutionDomesticPartnershipEndGPSSectionArea: Gps[],
	myCpgMidYearConfirmationLifeEventGPSTitle: string;
	myCpgMidYearConfirmationConfirmationLifeEventGPSSectionArea: Gps[],
	myCpgMidYearDivorceConfirmationGPSTitle: string;
	myCpgMidYearDivorceConfirmationGPSSectionArea: Gps[],
	myCpgMidYearAddingChildrenConfirmationGPSTitle: string;
	myCpgMidYearAddingChildrenConfirmationGPSSectionArea: Gps[],

	deathOfChildLifeEventGpsTitle: string;
	deathOfChildLifeEventGpsSectionArea: Gps[],
	judgementDecreeGpsTitle: string;
	judgementDecreeGpsContentArea: Gps[],
	lifeEventsLandingTitle: string;
	lifeEventsLandingContentArea: Gps[],

	// MAP Mid Year
	mapMidyearHoursIncreaseConfirmationSectionTitle: string;
	mapMidyearHoursIncreaseConfirmationSectionArea: Gps[],
	scheduledHourWhoWillEnrollSectionTitle: string;
	scheduledHourWhoWillEnrollSectionArea: Gps[],

	//cic
	cicFormGpsTitle: string;
	cicFormGps: Gps[],
}

export interface MapPortalProps {
	myAdminPortalTitle: string;
	quickActionsHeader: string;
	cancelText: string;
	doneText: string;
	defaultQuickActions: DefaultQuickActionGroup[];
	quickActions: QuickActionGroup[];
	guidesResourcesHeader: string;
	guidesResourcesBlocks: BaseBlockModel[];
	bottomMessage: string;
	pageIntro: string;
	adminRoleText: string;
	multipleAdminRoleText: string;
	roleNameMapping: KeyValuePair[];
	adminPendingEnrollmentBannerDescription: string;
	adminPendingEnrollmentBannerTitle: string;
	adminPendingEnrollmentBannerUrlText: string;

	// brand
	brandImage: string;
	brandImageAltText: string;
	bannerImage: string;
	bannerImageLink: string;
	bannerImageAltText: string;

	// search
	searchQuickActionsPrompt: string;
	searchQuickActionsModalHeader: string;
	searchQuickActionsPlaceholderText: string;
	searchQuickActionsButtonText: string;
	searchQuickActionsResultsHeader: string;
	searchQuickActionsNoResultsMessage: string;

	// add or remove
	addOrRemoveActionsPrompt: string;
	addOrRemoveActionsModalHeader: string;
	addOrRemoveInstructions: string;
	availableActionsHeader: string;
	addActionText: string;
	removeActionText: string;
	collapseAllText: string;
	collapseText: string;
	expandAllText: string;
	expandText: string;

	// reorder
	reorderActionsPrompt: string;
	reorderActionsHeader: string;
	reorderActionsInstructions: string;

	// sidebar
	latestUpdatesHeader: string;
	sidebarInfoBoxHeader: string;
	sidebarInfoBoxContent: string;
}

export interface ImageDescription {
	imageOnLeft: string;

	description: string;

	image: string;
}

export interface ClergyCompReportSettings {

	landingPageTitle: string;
	downloadReportDropdownTitle: string;
	provinceLabel: string;
	nonDomesticDioceseLabel: string;
	domesticLabel: string;
	nonDomesticLabel: string;
	mapHelperText: string;
	contentBelowMap: string;
	imageDescription: ImageDescription[];
	medianCompensationLabel: string;
	medianCompensationHelperTexts: string;
	hisCompLabel: string;
	demographicLabel: string;
	demographicSubTitle: string;
	demographicHelperText: string;
	reportDownloadLinks: TcsmActionLink[];

	globalClergyCompReportId: string;
	globalClergyCountReportId: string;
	globalClergyMedianCompReportId: string;
	globalClergyTotalReportId: string;
	internationalDemographicReportJson: string;
	domesticDemographicReportJson: string;
}


export interface ClergyBioSettings {
	apiErrorMessage: string;
	aboutInfo: string;
	byBishopLabel: string;
	canonicalResidence: string;
	childNameLabel: string;
	childrenTitle: string;
	noChildrenDescription: string;
	churchReportingDescription: string;
	churchReportingSubTitle: string;
	churchReportingTitle: string;
	coConsecratorsLabel: string;
	consecrationLabel: string;
	currentSpouseDescription: string;
	noCurrentSpouseDescription: string;
	currentSpouseLabel: string;
	previousSpouseLabel: string;
	deceasedSpouseLabel: string;
	dateLabel: string;
	dateOfBirthLabel: string;
	dateOfMarriageLabel: string;
	degreeLabel: string;
	diaconateLabel: string;
	ecclesiasticalTitle: string;
	educationTitle: string;
	endLabel: string;
	episcopalVolunteerTitle: string;
	fieldLabel: string;
	forLabel: string;
	genderIdentityLabel: string;
	genderLabel: string;
	honorsTitle: string;
	institutionLabel: string;
	lastNameAtBirthLabel: string;
	lastUpdatedLabel: string;
	ministryTitle: string;
	miscellaneousTitle: string;
	miscellaneousVolunteerTitle: string;
	nameAppearAsLabel: string;
	noInformationText: string;
	nonStipeTitle: string;
	notice: string;
	otherEducationTitle: string;
	parentLabel: string;
	noParentsDescription: string;
	parentNameLabel: string;
	personalInfoSubTitle: string;
	personalTitle: string;
	personalWebsiteLabel: string;
	placeAtBirthLabel: string;
	positionLabel: string;
	priesthoodLabel: string;
	professionalTitle: string;
	publicationsTitle: string;
	publishedAddressLabel: string;
	raceLabel: string;
	receptionLabel: string;
	relationshipTitle: string;
	religiousOrderLabel: string;
	sexualOrientationLabel: string;
	societiesTitle: string;
	spouseNameLabel: string;
	startLabel: string;
	stipeTitle: string;
	summaryTitle: string;
	theologicalEducationTitle: string;
	transferLabel: string;
	updateButtonText: string;
	volunteerTitle: string;
	yearLabel: string;
	personalUpdateHeader: string;
	personalUpdateDescription: string;
	firstNameLabel: string;
	middleNameLabel: string;
	lastNameLabel: string;
	placeOfBirthLabel: string;
	nameAppearAsFormLabel: string;
	personUpdateWebsiteLabel: string;
	publishedAddressHeader: string;
	publishedAddressSectionDescription: string;
	confirmationCheckBoxText: string;
	checkAllApplyLabel: string;
	genderSelfDescribeLabel: string;
	ethnicitiesSelfDescribeLabel: string;
	sexualSelfDescribeLabel: string;
	ecdHelperText: string;
	relationshipAboutSectionText: string;
	parentsExplanationSection: string;
	currentSpouseExplanationSection: string;
	previousSpouseExplanationSection: string;
	deceasedSpouseExplanationSection: string;
	childrenExplanationSection: string;
	legalFirstNameLabel: string;
	legalMiddleNameLabel: string;
	legalLastNameLabel: string;
	suffixLabel: string;
	stepChildLabel: string;
	addChildButtonText: string;
	removeChildButtonText: string;
	addChildErrorMessage: string;
	educationUpdateAboutSectionText: string;
	addTheologicalInstitutionButtonText: string;
	addOtherInstitutionButtonText: string;
	otherInstitutionLabel: string;
	otherDegreeLabel: string;
	stipendiaryUpdateDescription: string;
	employmentStartDateLabel: string;
	employmentEndDateLabel: string;
	positionTitleLabel: string;
	publishedPositionLabel: string;
	positionStartDateLabel: string;
	positionEndDateLabel: string;
	nonStipendiaryUpdateDescription: string;
	miscellaneousUpdateDescription: string;
	miscellaneousInstitutionLabel: string;
	addPositionButtonText: string;
	addNonStipendiaryButtonText: string;
	removeNonStipendiaryButtonText: string;
	addMiscellaneousButtonText: string;
	roleLabel: string;
	titleOfWorkLabel: string;
	nameOfPublicationLabel: string;
	publisherLabel: string;
	honorUpdateDescription: string;
	honorLabel: string;
	conferringOrgLabel: string;
	societyDescriptionLabel: string;
	yearBeginLabel: string;
	yearEndLabel: string;
	nameOfSocietyLabel: string;
	addPublicationButtonText: string;
	addHonorButtonText: string;
	addSocietyButtonText: string;
	professionalNoticeMessage: string;
	noticeTitle: string;
	episcopalUpdateDescription: string;
	miscellaneousVolunteerUpdateDescription: string;
	episcopalVolunteerAddButtonText: string;
	miscellaneousVolunteerAddButtonText: string;
	childCountText: string;
	noInformationOnFile: string;
	atLeastOnePositionMessage: string;
	newClergyRequiredMessage: string;
	errorMessageWhenNotSelectingFromAutoComplete?: string;
}
